import { SCHWAB_IRA } from './financialAccountTypes'

export const CONTRIBUTION_FORMULA = {
  CONTRIBUTION_FORMULA_FIELD_NAME: 'sepContributionFormula',
  CONTRIBUTION_FORMULA_FIELD_VALUE: 'B',
  SHOW_CONTRIBUTION_FORMULA_FIELD: { showFormulaValues : true },
  HIDE_CONTRIBUTION_FORMULA_FIELD: { showFormulaValues : false }
}

export const ALLOCATION_FORMULA = {
  ALLOCATION_FORMULA_FIELD_NAME: 'sepAllocationFormula',
  ALLOCATION_FORMULA_FIELD_VALUE: 'C',
  SHOW_ALLOCATION_FORMULA_FIELD: { showIntegratedFormula : true },
  HIDE_ALLOCATION_FORMULA_FIELD: { showIntegratedFormula : false }
}

export const MINIMUM_ALLOCATION = {
  MINIMUM_ALLOCATION_FIELD_NAME: 'sepTopHeavyMinimumAllocation',
  MINIMUM_ALLOCATION_FIELD_VALUE: 'B',
  SHOW_MINIMUM_ALLOCATION_FIELD: { showMinimumAllocationDetails : true },
  HIDE_MINIMUM_ALLOCATION_FIELD: { showMinimumAllocationDetails : false }
}

export const PLAN_YEAR = {
  PLAN_YEAR_FIELD_NAME: 'sepPlanYearElections',
  PLAN_YEAR_FIELD_VALUE: 'C',
  SHOW_PLAN_YEAR_FIELD: { showPlanYearDetails : true },
  HIDE_PLAN_YEAR_FIELD: { showPlanYearDetails : false }
}

export const SIMPLE_ELIGIBILITY = {
  SIMPLE_ELIGIBILITY_FIELD_NAME: 'simpleEligibilityServiceRequirement',
  SIMPLE_ELIGIBILITY_FIELD_VALUE: 'B',
  SHOW_SIMPLE_ELIGIBILITY_FIELD: { showSimpleElegibiltyDetails: true },
  HIDE_SIMPLE_ELIGIBILITY_FIELD: { showSimpleElegibiltyDetails: false }
}

export const EMPLOYER_CONTRIBUTIONS = {
  EMPLOYER_CONTRIBUTIONS_FIELD_NAME: 'simpleCatchUpContributionsPermitted',
  EMPLOYER_CONTRIBUTIONS_FIELD_VALUE: 'No',
  SHOW_EMPLOYER_CONTRIBUTIONS_FIELD: { showEmployerContributionsDetails: true },
  HIDE_EMPLOYER_CONTRIBUTIONS_FIELD: { showEmployerContributionsDetails: false }
}

const simpleIraSections = [
  'eligibility',
  'contributions'
]

export const showSection = (subType, section) => {
  if (subType === SCHWAB_IRA.ACCOUNT_TYPES.SIMPLE_IRA) {
    return simpleIraSections.includes(section)
  }

  return true
}

export default {
  simpleIraSections,
  showSection,
  CONTRIBUTION_FORMULA,
  ALLOCATION_FORMULA,
  MINIMUM_ALLOCATION,
  PLAN_YEAR,
  SIMPLE_ELIGIBILITY,
  EMPLOYER_CONTRIBUTIONS
}



// WEBPACK FOOTER //
// ./src/utils/financialAccountAdditionalDetails.js